import getFocusedFilterForTable from './getFocusedFilterForTable';
import getSelectedTableView from './getSelectedTableView';

/**
 *
 * @returns state of mail list (focused/other/primary)
 */
export default function getFocusedViewFilter() {
    return getFocusedFilterForTable(getSelectedTableView());
}
